// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2gbJN","list":"styles_list__BO13y"};